function AboutMe() {
  return (
    <div className="bgimg">
      <h1>About Me!</h1>
      <img
        src="https://i.imgur.com/vYUd0Z2.jpg"
        width="375"
        height="600"
        className="castlephoto"
        alt="myphoto"
      />
      <h2> My languages and tools!</h2>
      <div class="techstack">
        <img
          src="https://raw.githubusercontent.com/devicons/devicon/1119b9f84c0290e0f0b38982099a2bd027a48bf1/icons/react/react-original-wordmark.svg"
          title="React"
          alt="React"
          width="100"
          height="100"
        />
        <img
          src="https://raw.githubusercontent.com/devicons/devicon/1119b9f84c0290e0f0b38982099a2bd027a48bf1/icons/css3/css3-plain-wordmark.svg"
          title="CSS3"
          alt="CSS"
          width="100"
          height="100"
        />
        <img
          src="https://raw.githubusercontent.com/devicons/devicon/1119b9f84c0290e0f0b38982099a2bd027a48bf1/icons/html5/html5-plain-wordmark.svg"
          title="HTML5"
          alt="HTML"
          width="100"
          height="100"
        />
        <img
          src="https://raw.githubusercontent.com/devicons/devicon/1119b9f84c0290e0f0b38982099a2bd027a48bf1/icons/nodejs/nodejs-original-wordmark.svg"
          title="NodeJS"
          alt="NodeJS"
          width="100"
          height="100"
        />
        <img
          src="https://raw.githubusercontent.com/devicons/devicon/1119b9f84c0290e0f0b38982099a2bd027a48bf1/icons/git/git-original-wordmark.svg"
          title="Git"
          alt="git"
          width="100"
          height="100"
        />
        <img
          src="https://raw.githubusercontent.com/devicons/devicon/1119b9f84c0290e0f0b38982099a2bd027a48bf1/icons/mongodb/mongodb-original-wordmark.svg"
          title="MongoDB"
          alt="mdb"
          width="100"
          height="100"
        />
        <img
          src="https://raw.githubusercontent.com/devicons/devicon/1119b9f84c0290e0f0b38982099a2bd027a48bf1/icons/javascript/javascript-original.svg"
          title="JS"
          alt="js"
          width="100"
          height="100"
        />
        <img
          src="https://raw.githubusercontent.com/devicons/devicon/1119b9f84c0290e0f0b38982099a2bd027a48bf1/icons/trello/trello-plain-wordmark.svg"
          title="TRL"
          alt="trl"
          width="110"
          height="110"
        />
        <img
          src="https://raw.githubusercontent.com/devicons/devicon/1119b9f84c0290e0f0b38982099a2bd027a48bf1/icons/vscode/vscode-original-wordmark.svg"
          title="VSC"
          alt="vsc"
          width="100"
          height="100"
        />
        <img
          src="https://raw.githubusercontent.com/devicons/devicon/master/icons/typescript/typescript-original.svg"
          title="TS"
          alt="ts"
          width="100"
          height="100"
        />
        <img
          src="https://raw.githubusercontent.com/tandpfun/skill-icons/main/icons/Postman.svg"
          title="PM"
          alt="pm"
          width="100"
          height="100"
        />
      </div>
      <h2>
        In addition to being a proud pet parent of both a dog (Beauty) and a cat
        (Chicken), I also love to make the most of my free time by visiting
        DisneyWorld, spending quality time with my family over delicious tacos,
        and creating cherished memories through fun activities.
      </h2>
      <h2>
        I am a big fan of exploring flea markets as they offer an element of
        surprise and the potential to discover hidden treasures. In the same
        vein, I also relish the opportunity to fully immerse myself in coding,
        taking the time to thoroughly understand each language and deepen my
        knowledge.
      </h2>
    </div>
  );
}

export default AboutMe;
